import FlexPane from './_flex-pane.js'
import KeyValueMap from './_key-value-map.js'

export default {
  name: 'EventListMarketsSection',
  values: {
    container: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '8px',
        style: {
          alignItems: 'center',
          width: '62%',
          _mobile_width: '184px',
          _mobile_minWidth: '184px',
        },
      },
    },
    sportWidthOverride: {
      configSet: KeyValueMap,
      configValues: {
        _mobile_tennis: '150px',
      },
    },
    marketColumnMinWidth: '165px',
    maxMarketColumnCount: 3,
    _mobile_maxMarketColumnCount: 1,
  },
  meta: {
    extendable: false,
  },
}
